import React from 'react';

const PenSvg = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1038 1.16848C13.3158 0.956543 13.5674 0.788429 13.8443 0.673731C14.1212 0.559034 14.418 0.5 14.7177 0.5C15.0174 0.5 15.3142 0.559034 15.5911 0.673731C15.868 0.788429 16.1196 0.956543 16.3315 1.16848C16.5435 1.38041 16.7116 1.63201 16.8263 1.90891C16.941 2.18582 17 2.4826 17 2.78232C17 3.08204 16.941 3.37882 16.8263 3.65573C16.7116 3.93263 16.5435 4.18423 16.3315 4.39617L5.43807 15.2896L1 16.5L2.21038 12.0619L13.1038 1.16848Z"
        stroke="#434343"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PenSvg;
